<template>
    <div class="page">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/offers.png" />
        </header>

        <div class="scroller2 green">
            <header>
                <h2 style="line-height: 28px; width: calc(100% - 20px)">{{ offer.title }}</h2>
                <ul class="links">
                    <li>
                        <a class="cancel" @click.prevent="goToLocation" href="#">
                            <x-icon class="icon" />
                        </a>
                    </li>
                </ul>
            </header>

            <partials @onSaved="saved = true" @onEdit="isEditMode" @onOfferLoaded="setOffer" />
        </div>
    </div>
</template>

<script>
import FadeImage from "@/components/App/fade-image";
import { XIcon } from "vue-feather-icons";
import Partials from "@/views/Pro/Offers/partials/form";
export default {
    name: "offer-new",
    components: { FadeImage, Partials, XIcon },
    data() {
        return {
            offer: false,
            saved: false,
            editMode: false,
        };
    },
    methods: {
        isEditMode(val) {
            this.editMode = val;
        },
        goToLocation() {
            if (!this.editMode) {
                this.$router.back();
                return;
            }

            if (this.saved) {
                this.$router.back();
                return;
            }

            this.$confirm("Are you sure you want to exit this record without saving?", () => {
                this.$router.back();
            });
        },
        setOffer(offer) {
            this.offer = offer;
        },
    },
};
</script>

<style lang="scss"></style>
